import axiosClient, { axiosClientAdmin } from "@/lib/auth";
import { UseMutationOptionsAny } from "../query";
import { RelayDto } from "@/lib/integrationTypes/integrationTypes";

export type OperateRelayInput = {
  companyId: string;
  projectId: string;
  relayId: string;
  turnOn: boolean;
};

export type CreateRelayInput = {
  name: string;
  componentGroupId: string;
  relatedComponentGroups?: string[];
  enabled?: boolean;
};

export type UpdateRelayInput = {
  id: string;
  name: string;
  componentGroupId?: string;
  relatedComponentGroups?: string[];
  enabled?: boolean;
};

export type DeleteRelayInput = {
  id: string;
};

export const operateRelay = async (input: OperateRelayInput) => {
  await axiosClient.post(
    `/company/${input.companyId}/project/${input.projectId}/Monitoring/relays/${input.relayId}`,
    null,
    {
      params: {
        turnOn: input.turnOn
      }
    }
  );
};

export const OperateRelayMut = () => {
  return {
    mutationFn: operateRelay,
    mutationKey: ["operateRelay"],
  } satisfies UseMutationOptionsAny;
};

// Create relay component
export const createRelay = async (input: CreateRelayInput): Promise<RelayDto> => {
  const { data } = await axiosClientAdmin.post<RelayDto>("/Integration/relay", input);
  return data;
};

export const CreateRelayMut = () => {
  return {
    mutationFn: createRelay,
    mutationKey: ["createRelay"],
  } satisfies UseMutationOptionsAny;
};

// Update relay component
export const updateRelay = async (input: UpdateRelayInput): Promise<RelayDto> => {
  const { data } = await axiosClientAdmin.put<RelayDto>(`/Integration/relay/${input.id}`, input);
  return data;
};

export const UpdateRelayMut = () => {
  return {
    mutationFn: updateRelay,
    mutationKey: ["updateRelay"],
  } satisfies UseMutationOptionsAny;
};

// Delete relay component
export const deleteRelay = async (input: DeleteRelayInput): Promise<void> => {
  await axiosClientAdmin.delete(`/Integration/relay/${input.id}`);
};

export const DeleteRelayMut = () => {
  return {
    mutationFn: deleteRelay,
    mutationKey: ["deleteRelay"],
  } satisfies UseMutationOptionsAny;
};